export const common = {
  welcome: 'Bienvenido',
  save: 'Guardar',
  cancel: 'Cancelar',
  loading: 'Cargando...',
  search: 'Buscar',
};
